const common = {
  createdAt: 'Creation Time',
  createdBy: 'Created User',
  updatedAt: 'Update Time',
  updatedBy: 'Updated User',
  expiredAt:'Expired At ',
  operation: 'Operation',
  yes: 'yes',
  no: 'no',
  all: 'all',
  salesMen: 'Sales Men',
  serviceMen: 'Service Men',
  user: 'User',
  followers: 'Follwers',
  authUsers: "Authorized Users",
  record: 'Modification Record',
  details: 'Modification Details',
  okText: 'confirm',
  cancelText: 'cancel',
  startTime: 'Start Time',
  endTime: 'End Time',
  open: 'open',
  close: 'close',
  operationUser: 'Operation User',
  mobile: 'Mobile',
  organization: 'Organization',
  request: 'Request',
  changeTime: 'Modification Time',
  deviceCode: 'Device Code',
  deviceName: 'Device Name',
  deviceType: 'Device Type',
  deviceAddress: 'Device Address',
  model: 'Model',
  customer: 'Customer',
  customerName: 'Customer',
  protocolCode: 'Protocol Code',
  driverType: 'Driver Type',
  intervalTime: 'Interval(s)',
  dtuCode: 'DtuCode',
  brand: 'Brand',
  installAddress: 'Address',
  measurement: 'Measurement',
  initialValue: 'InitialValue',
  remark: 'Remark',
  power: 'Power',
  pressure: 'Pressure',
  warrantyPeriod: 'Warranty Period',
  isStationDevice: 'Is Station Device',
  update: 'Update',
  nd: 'No data',
  none: 'none',
  picture: 'Picture',
  audio: 'Audio',
  second: 'Second',
  minute: 'Minute',
  hour: 'Hour',
  week: "Week",
  sd: 'Click confirm to delete'
}

const messages = {
  cti: 'Please complete the relevant time information',
  ctr: 'Please select the correct time frame',
  ctrt: 'Please select the correct time frame',
  logFail: 'Login fail',
  placeSearchFail: 'No result was found in the modification record or the input was incorrect (place names or common keywords cannot be searched directly)',
  fetchFail: 'Request failed',
  noDevice: 'No device information is available',
  rri: 'The replacement range is incorrect',
  ctrd: 'Are you sure to delete ?',
  ftd: 'fail to delete',
  np: 'No permission',
  company_empty: 'Please enter the company name',
  address_empty: 'Please enter the company address',
  area_empty: 'Please enter a area',
  province_empty: 'Please enter a province',
  city_empty: 'Please enter a city',
  cta: 'Are you sure to add it?',
  peu: 'Please enter your username',
  pem: 'Please enter your phone number',
  pemp: 'Please enter 11-digit mobile number',
  peo: 'Please select an owning organization',
  per: 'Please select a role',
  pedc: 'Please enter the device number',
  lon: 'You can enter only upper and lower case letters or numbers',
  pedn: 'Please enter the device name',
  pedm: 'Please enter specifications',
  peda: 'Please enter the station number address',
  pedt: 'Please select the device type',
  pec: 'Please select Customer',
  pedd: 'Please enter driver type',
  pedp: 'Please enter protocol code',
  pedtu: 'Please enter dtucode',
  error: 'Error',
  spk: 'No result was found in the modification record or the input was incorrect (place names or common keywords cannot be searched directly)',
  saASe_empty: 'Salesmen and waiters cannot be empty',
  ctd: 'Are you sure to dismantle the device ?',
  ctr: 'Are you sure to recover the device ?',
  cts: 'Are you sure to dismantle the station',
  confirmD: 'Click OK to dismantle the device',
  confirmR: 'Click OK to recover the device',
  confirmS: 'Click OK to dismantle the station',
  es: 'Export successfully',
  psi: 'Please select interval',
  unspportedAudio: 'Your browser does not support the audio tag.',
  selectServiceType: 'Please select a service type',
  selectDevice: 'Please select device',
  enterServicehours: 'Please enter service hours',
  enterServiceContent: 'Please enter service content',
  enterServiceMan: 'Please enter service man',
  enterhoursNumber: 'Service hours and running hours can only be entered in numbers',
  lessThan500MB: 'The file must be less than 500MB',
  lessThan1MB: 'The file must be less than 1MB',
  rightFile: 'Only files in the correct format can be uploaded',
  ctrp: 'Are you sure to delete the picture?',
  hint: 'hint',
  rs: 'successfully delete',
  cr: 'cancel delete',
  ctraudio: 'Are you sure you want to delete audio',
  enterModel: 'Please enter the device model',
  success: 'success',
  fail: 'fail',
  orderNo: 'Please enter the order number',
  orderType: 'Please select the order type',
  orderScore: 'Please enter order score',
  finishTime: 'Please select an estimated completion time',
  customerId: 'Please select Customer',
  deviceId: 'Please select device',
  ctrwi: 'Are you sure to delete fault information?',
  ctrwic: 'Click confirm to delete the fault information',
  peymn: 'Please enter your mobile number',
  peyp: 'Please enter your password',
  pev: 'Please enter the verification code',
  turac: 'The user requires a captcha',
  wp: 'wrong password',
  eon: 'Please enter the organization name',
  ecc: 'Please enter the client code',
  ecn: 'Please enter the client name',
  YSBID: 'Please enter ID',
  YSBName: 'Please enter name',
  JDO: 'Please select a JDY organization',
  JDD: 'Please select a JDY Department',
  moreThanOneMonth: 'Date range can not be more than a month'
}

const placeholder = {
  mobile: 'Please enter phone number',
  contactPerson: 'Please enter contact person',
  searchCustomer: 'Search customer',
  searchProtocolCode: 'Search protocol code',
  points: 'Please select a point',
  device: 'Please select a device',
  timeRange: 'Please select a time range',
  templateName: 'Please enter a template name',
  t: 'Types of the device that can be queried'
}

const buttons = {
  fullscreen: 'Fullscreen',
  search: 'Search',
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  logout: 'logout',
  save: 'Save',
  goBack: 'Return',
  export: 'Export',
  exportHistory: 'Historical data export',
  uploadPic: 'Upload picture',
  uploadAud: 'Upload audio',
  refresh: 'Refresh',
  reset: 'Reset',
  comparisonOfGasElectricityRatio: 'compare gas electric ratio',
  time: 'compare by time',
  bind: 'bind',
  history: 'Delete historical data',
  fold: 'Fold',
  expand: 'Expand',
  zoomIn: 'Zoom In',
  hyperlink: "Hyperlink",
  addParam: "Add parameter"
}

const login = {
  title: 'Login',
  logIn: 'Login',
  username: 'Username',
  password: 'Password',
  r: 'remember password',
  button: 'login',
  getCaptcha: 'Get Captcha',
  forgetPassword: 'Forget password',
  resetPassword: 'Reset password',
  getLater: ' seconds can',
  returnLogin: 'Back to login'
}

const overview = {
  service: 'Service',
  monitor: 'Monitor',
  list: 'Warning',
  bigData: "Big Data",
  serviceContent: {
    dispatchD: '<span style="font-size: 0.24rem">Dispatch</span><br/><span style="font-size: 0.18rem">today</span>',
    serviceD: '<span style="font-size: 0.24rem">Service</span><br/><spanspan style="font-size: 0.18rem">today</span>',
    serviceM: '<span style="font-size: 0.24rem">Service</span><br/><spanspan style="font-size: 0.18rem">last 30 days</span>',
    dispatchM: '<span style="font-size: 0.24rem">Dispatch</span><br/><spanspan style="font-size: 0.18rem">last 30 days</span>',
    statistics: 'Statistics of service in 7 days',
    volume: 'Top10 service volume in 30 days',
    fault: 'Warning trend in six months',
    maintain: 'The proportion of maintenance types',
    dispatch: 'Dispatch list'
  },
  monitorContent: {
    title: 'Data Monitor',
    status: 'Running Status',
    Analysis: 'Device Analysis',
    Distribution: 'Top10 Device Distribution',
    open: 'opening',
    loadRate: 'load rate',
    temp: 'temperature',
    emission: 'Emission Reduction',
    electricityConsumption: 'Electricity Consumption',
    CO2: 'CO₂ emission reduction',
    trend: 'Emission Reduction Trends',
    year: 'Emission Reduction Details',
    ye: 'Electricity(kW·h)',
    yc: 'CO₂(t)',
    me: 'Electricity(kW·h)',
    mc: 'CO₂(t)',
    de: 'Electricity(kW·h)',
    dc: 'CO₂(t)',
    city: 'City CO₂ Emission Reduction Contribution (10,000 t)',
    device: 'Device',
    agent: 'Agent',
    user: 'User'
  },
  listContent: {
    title: 'Deman Warning List',
    setting: ' setting',
    pageGap: 'Time to the Next Page',
    rows: 'Rows Per Page',
    total: 'Total Rows',
    extra: 'Enter -1 to query all data',
    replaceWord: 'Word to Replace Company',
    replaceRange: 'Range of Replacement',
    type: 'Visible Warning Types',
    fontSize: 'Font Size'
  },
  bigDataContent: {
    title: "Deman Data Monitor",
    sleep: "Sleep",
    prepare: "Prepare",
    powerOff: "Power off",
    powerOnPercent: "Opening",
    loadRate: "Load Rate",
    temp: "Temperature",
    monitoringDevice: "Monitor Device",
    device: "Device Count",
    user: "User Count",
    emissionReduction: "Emission Reduction",
    CO2: 'CO₂ Reduction',
    warning: "Customer Early Warning List",
    year: "Emission Reduction in the Year",
    theYear: "This year",
    month: "This month",
    day: "Today",
    C: "Carbon Reduction",
    trend: "Annual Reduction Trends"
  }
}

const user = {
  title: 'Users List',
  OpenCheck: 'Open Check',
  columns: {
    name: 'Name',
    mobile: 'Cell Phone Number',
    organization: 'Organization',
    role: 'Role',
    requiredCaptcha: 'Verification Required',
    enabled: 'Enabled',
    loginPlatform: 'Login Platform'
  },
  modal: {
    PC: 'PC',
    mobile: 'mobile',
    organization: 'organization',
    resetPassword: 'Reset password',
    authorities: 'Authorities',
    deviceModifyCnt: 'Device Modify Count',
    sac: 'Switch authorized customers',
    appVersion: "App Version",
    allowedDeviceTypes: "Allowed Device Types"
  },
  bashPut: "Batch update of APP versions",
  active: "User Active Analyse",
  eav: "Please enter the App version",
  newApp: "New App Version"
}

const region = {
  title: 'Provincial, municipal and district management',
  sc: 'Please search country',
  code: 'Code of administrative division'
}

const customer = {
  title: 'Customer List',
  company: 'Compnay',
  address: 'Address',
  realName: 'User Name',
  organizationName: 'User Organization',
  addTitle: 'Add customer',
  editTitle: 'Edit Customer',
  mobile: 'Mobile',
  contactPerson: 'Contact Person',
  area: 'Area',
  province: 'Province',
  city: 'City',
  country: 'Country',
  country_empty: 'Please select a country',
  deviceBeingUsed: 'Device Bejing Used',
  maintainSmsEnabled: 'Maintain Sms Enabled',
  inspectionSmsEnabled: 'Inspection Sms Enabled',
  errorSmsEnabled: 'Error Sms Enabled',
  add: 'add',
  addDevice: 'add device',
  ssqSetting: 'Province/city/area Settings',
  searchCountry: "Search country",
  searchProvince: 'Search Province',
  searchCity: 'Search City',
  searchArea: 'Search Area',
  ssqFormModalTitle: 'Province/city/area',
  parent: 'Parent',
  administrativeLevel: 'Administrative Level'
}

const device = {
  title: 'Device List',
  code: 'Device Code',
  status: 'Status',
  organization: 'Organization',
  businessType: 'Business Type',
  countDown: 'Countdown',
  dtuStatus: 'Module Status',
  rsm: 'Restart module ?',
  enable: 'Dismantled',
  yes: 'yes',
  no: 'no',
  history: 'data',
  details: 'Device Details',
  monitor: 'Monitor',
  map: 'Position',
  bindingDevice: 'Binding Device',
  deviceSelect: 'select device',
  writeValue: 'write value',
  switchDevice: 'switch',
  moduleChanged: 'change module',
  deviceInfo: 'device info',
  deviceConnect: 'device connect',
  pointCode: 'point code',
  value: 'value',
  np: 'no position',
  readOnlyParameters: 'ReadOnly Parameters',
  writableParameters: 'Writable Parameters',
  errorParameters: 'Error Parameters',
  dataUpdateTime: 'Update Time',
  analyze: 'analyze',
  write: 'write',
  failure: 'Failure',
  sOrganization: 'Serivce Organization',
  runTime: 'RunTime',
  maintainTime: 'Maintain Time',
  maintainSettingTime: 'Maintain Setting Time',
  powerOnTime: 'Power On Time',
  detailsInfo: 'Details',
  count: 'Collection rate statistics',
  analysis: 'data analysis',
  acquisitionInterval: 'Acquisition interval: ',
  expection: 'Expected data volume: ',
  real: 'Actual data volume: ',
  rate: 'Data collection rate: ',
  setParameters: 'Set Parameters: ',
  setRange: 'Set Range: ',
  setValue: 'Set Value: ',
  errorName: 'Error Name: ',
  transducerCode: 'Transducer Code: ',
  reasons: 'Possible Reasons',
  refreshErrorList: 'Refresh error list',
  deviceSwitch: 'Device Switch',
  open: 'open',
  close: 'close',
  continueToListen: 'seconds continue to monitor',
  bitRule: 'Bit',
  valueRule: 'Value',
  endMonitor: 'Monitoring has ended',
  kl: 'Keep listening',
  preview: 'Preview',
  exportP: 'Export according to the selected parameters: ',
  exportI: 'Interval for exporting data: ',
  count: 'Count Collection Rate',
  distribution: 'Data distribution range statistics',
  distributionD: 'Data distribution range statistics Details',
  addRange: 'add range',
  analysis: 'data analysis',
  countermand: 'countermand',
  range: 'range',
  chart: 'Generate chart',
  removeRange: 'remove range',
  acquisitionInterval: 'Acquisition interval: ',
  expection: 'Expected data volume: ',
  real: 'Actual data volume: ',
  rate: 'Data collection rate: ',
  acquisitionDate: 'Data acquisition date',
  warning: 'Warning List',
  warningID: 'Warning ID',
  warningName: 'Warning Name',
  warningType: 'Warning Type',
  warningDimension: 'Warning Dimension',
  content: 'Content',
  mobile: 'Phone Number',
  deviceType: 'device',
  stationType: 'station',
  empty: 'No warnings',
  sOrganization: 'Service Organization',
  runTime: 'Running Time',
  maintain: 'Maintain Time',
  mst: 'Maitain Setting Time',
  pot: 'Power On Time',
  rsm: 'Restart module ?',
  startTime: 'Start Time',
  endTime: 'End Time',
  countDown: 'Countdown',
  summary: 'Summary',
  confirm: 'Confirm deletion',
  selectDate: 'Please select date',
  selectTime: 'Please select time',
  selectRange: 'Please select time range',
  workingTemperature: 'Working Temperature(℃)',
  workingPressure: 'Working Pressure(Mpa)',
  workingFlow: 'Working Flow(m³)',
  addTitle: 'Add Device',
  Continuous: 'Display data continuously: ',
  searchTooltip: 'When filtering data parameters, basic parameter conditions are mandatory',
  loadRateCalculation: 'Load rate calculation',
  dateRange: 'Date Range',
  unloadingPower: 'Unloading Power',
  fullLoadPower: 'Full Load Power',
  stanbyPower: 'Stanby Power',
  noPoints: 'No points',
  selectPoints: 'Please select a point',
  result: 'Result',
  electricityMeterAccumulation: 'Electricity Meter Accumulation',
  maxPower: 'Max Power',
  minPower: 'Min Power',
  loadingRate: 'Loading Rate',
  capacityRate: 'Capacity Rate',
  description: {
    dateRange: 'The date range used for calculation',
    unloadingPower: 'Power consumption during uninstallation',
    fullLoadPower: 'The power when fully loaded',
    stanbyPower: 'Data below the shutdown power level are not included in the calculation.',
    aPower: 'Average power within the time range',
    electricityMeterAccumulation: 'Cumulative power consumption difference between end time and start time',
    maxPower: 'The maximum power value within the selected time period',
    minPower: 'The minimum power value within the selected time period',
    loadingRate: 'The number of points greater than the unloading power / total number of points',
    capacityRate: 'Average power / Full-load power'
  },
  enterUnloadingPower: 'Please enter unloading power',
  enterFullLoadPower: 'Please enter full load power',
  enterStanbyPower: 'Please enter stanby power',
  enterNumber: 'Please enter a number',
  compeleteInfo: 'Please compelete information',
  IndustrialFrequency: 'Industrial Frequency',
  variableFrequency: 'Variable Frequency',
  dataCount: 'Data Count',
  loadCount: 'Load Count',
  unloadCount: 'Unload Count',
  unloadRate: 'Unload Rate',
  ctoc: "Confirm to open or close ?",
  hint: "Hint",
  delay: "Delay(s)",
  warningRemind: "Warning Remind List",
  warningTag: "Warning Tag",
  axis: "Chart scale range setting",
  enterMinAxis: "Please enter the minimum value of the scale range.",
  enterMaxAxis: "Please enter the maximum value of the scale range.",
  modifyParameter: "Allow modification of runtime parameters",
  modifyParameter_confirm_title: "Confrim to change allow modification of runtime parameters？",
  modifyParameter_confirm_content: "Click confrim to change allow modification of runtime parameters",
  clearCharts: "Clear Charts",
  diff: "You can choose different device parameters for comparison."
}

const orders = {
  title: 'Orders List',
  add: 'add order',
  code: 'Code',
  type: 'Type',
  state: 'State',
  receiver: 'Receiver',
  cancelState: 'Cancel State',
  yes: 'no',
  no: 'yes',
  contactPerson: 'Contact Person',
  orderScore: 'Order Score',
  finishTime: 'Finish Time',
  rush: 'rush',
  ratio: 'Ratio',
  helper: 'Helper',
  tab: 'Dispatch list',
  cancel: 'Cancel',
  confirmTitle: 'Do you confirm the cancellation of the order?',
  clickToConfirm: 'Click Confirm to cancel the order',
  unreasonableDistribution: 'The distribution of points is not reasonable',
  details: 'Order Details',
  distance: 'Distance',
  score: 'Order Evaluation',
  addHelper: 'Add helper',
  orderInfo: 'Order Information',
  ID: 'Order ID',
  nd: 'No Distance',
  rse: 'The percentage of points is incorrectly assigned',
  eos: 'Please enter the order evaluation score'
}

const order_operators = {
  title: 'Order Operators',
  add: 'Add operator',
  integral: 'Integral',
  name: 'Name',
  su: 'Please select a user',
  ei: 'Please enter integral',
  sr: 'Please select a receiver',
  failedValid: 'The form verification fails',
  editRole: 'Edit role',
  addHelper: 'Add helper',
  editHelper: 'Edit helper',
  editReciver: 'Edit receiver'
}

const saleDocument = {
  title: 'Service Document',
  add: 'add service document',
  addTitle: 'Add service document',
  editTitle: 'Edit service document',
  serviceType: 'Service Type',
  updateman: 'Update Man',
  serviceTime: 'Service Time',
  updateTime: 'Update Time',
  createman: 'Creation Man',
  createTime: 'Creation Time',
  modal: {
    FWLX: 'Device ownership',
    DM: 'Deman Device',
    el: 'Else',
    sbxh: 'Model',
    runTime: 'Runtime',
    servicehours: 'Service Hours',
    serviceContent: 'Service Content'
  },
  tab: 'Service Document'
}

const station = {
  title: 'Station List',
  code: 'Station Code',
  name: 'Station Name',
  enable: 'Dismantled',
  enableY: 'yes',
  enableN: 'no',
  preview: 'Preview',
  configuration: 'Configuration',
  pm: 'parameter configuration',
  organization: 'Organization',
  enable: 'Dismantled',
  preview: 'Preview',
  statistics: 'Statistics',
  dataReport: 'Data Statistic',
  dataReport1: "Data Report",
  warning: 'Warning Setting',
  configuration: 'Configuration',
  data: 'Data',
  effectiveState: 'Efficiency',
  accumulate: 'Accumulate',
  electricity: 'Electricity',
  flow: 'Flow',
  electricityL: 'Electricity',
  flowL: 'Flow',
  ratio: 'Ratio: ',
  current: 'Current',
  socialBenefit: 'Social Benefit',
  es: 'Energy Saving',
  cr: 'CO₂ Reduction',
  ec7: 'Energy Consumption in 7 days',
  ratioT: 'Ratio',
  gas: 'Gas',
  electricity: 'Electricity',
  state: 'Device State',
  running: 'Running',
  standby: 'Standby',
  offline: 'Offline',
  error: 'Error',
  maintain: 'Maintain',
  pressure: 'Pressure',
  pressureC: 'current pressure',
  warn: 'Warning Info',
  ds: 'Select Device',
  LLJ: 'Flow Meter',
  DB: 'Electricity Meter',
  NXFXY: "Energy Efficiency Analyzer",
  key: 'Key Parameter',
  aGas: 'Average gas consumption',
  gas: 'Flow',
  aPower: 'Average Power',
  power: 'Electricity Meter Accumulation',
  aPressure: 'Average Pressure',
  today: 'today',
  yesterday: 'yesterday',
  ratioTO: "Today's ratio analysis",
  cf: 'Current Flow',
  cp: 'Current Power',
  cra: 'Current Gas-electric Ratio',
  dc: 'Device Comparison',
  tld: 'Last day',
  tlw: 'Last week',
  tlm: 'Last month',
  colors: 'Colors of Device Status',
  wf: 'Working Condition Flow',
  sdt: 'device for temperature',
  spt: 'parameter for temperature',
  eav: 'please enter an analog value',
  analog: 'analog',
  sdp: 'device for pressure',
  spp: 'parameter for pressure',
  pm: 'parameter configuration',
  addTitle: 'Add station',
  editTitle: 'Edit station',
  flow: 'Flow',
  gasElectricRatio: 'Gas-electricity ratio',
  interval: 'Interval',
  charts: 'Charts',
  gasUnit: 'Unit of Gas',
  showElec: "Show electricity meter",
  selectStation: 'Stations',
  ss: 'Please select stations',
  esc: 'Please enter station code',
  esn: "Please enter station name",
  ecn: 'Please enter customer name',
  deviceSelect: 'Device',
  calculationSetting: 'Device Parameter Calculation Configuration',
  deleteConfiguration: 'Delete configuration',
  parameters: 'Parameters',
  selfDefinedParameters: 'Self-defined Parameters Setting',
  setExpression: 'Set expression',
  seDevice: 'Only display selected devices',
  searchDeviceCodeOrName: 'Search for the device code or name',
  sePoints: 'Only display selected parameters',
  searchPointCodeOrName: 'Search for the parameter code or name',
  paramCode: 'Param Code',
  paramName: 'Param Name',
  expression: 'Expression',
  paramsSetting: 'Params Setting',
  fullscreenTime: 'Fullscreen Time',
  LLJParameter: "Parameter of Flow Meter",
  DBParameter: "Parameter of Electricity",
  flowUnit: "Flow Unit"
}

const configuration = {
  title: '2D real-time monitoring configuration editing',
  toggleTo: 'toggle to ',
  associated: 'associated station',
  backgroundColor: 'background color',
  style: 'Style',
  data: 'Data',
  width: 'width',
  height: 'height',
  scaleX: 'scale(X)',
  scaleY: 'scale(Y)',
  rotate: 'rotate',
  zIndex: 'priority',
  fontFamily: 'font family',
  fontSize: 'font size',
  color: 'font color',
  borderRadius: 'border radius',
  backgroundColor: 'background',
  content: 'content',
  bind: 'device binding',
  device: 'device',
  parameter: 'parameter',
  warningSettingTableParameter: "parameter(avarage)",
  unit: 'unit',
  show: 'show',
  station: 'station',
  text: 'text',
  cp: 'controls parameter',
  range: 'range',
  coefficient: 'coefficient',
  default: 'default value',
  chartsSetting: 'Charts Setting',
  yPosition: 'Y Position',
  xPosition: 'X Position',
  max: 'points limit',
  aggregationType: 'Aggregation',
  SUM: 'Summation',
  DIFF: 'Difference',
  term: 'Cycle',
  day: 'Day',
  month: 'Month',
  terms: 'Cycles',
  updateTerm: 'Update per',
  chartType: 'Chart Type',
  Y: 'Y axis',
  X: 'X axis',
  XFontSize: 'X font size',
  XFontColor: 'X font color',
  YFontSize: 'Y font size',
  YFontColor: 'Y font color',
  labelFont: 'Label size',
  labelColor: 'Label color',
  decimals: 'Decimals',
  returnOrigin: 'If this parameter is not configured, the original data is returned',
  linear: 'Gradient',
  barColor: 'Bar Color',
  lineColor: 'Line Color',
  linearStart: 'Linear start',
  linearEnd: 'Linear end',
  dataRate: "Data Rate",
  pleaseCompleteForm: "Please complete form"
}

const history = {
  machineType: 'Machine Type',
  dateRange: 'Date Range',
  calculate: 'Calculate',
  export: 'Export Interval Gap',
  savePoints: "Save Points",
  success: "Success",
  dataRange: "Data Range: ",
  range: "Range: ",
  filter: "Filter",
  exportByFilterOptions: "Export by filter options"
}

const maintain = {
  set: 'settings',
  title: 'Maintain Data',
  startTime: 'Start Time',
  endTime: 'End Time',
  startRunningTime: 'Start Running Time',
  endRunningTime: 'End Running Time'
}

const runningData = {
  title: 'Average Running Data',
  year: '.',
  machineCode: 'Machine Code',
  model: 'Model',
  company: 'Company',
  area: 'Area',
  start: 'Start Time',
  end: 'End Time',
  type: 'Type',
  pr: 'Power Range(kW)',
  month: ' ',
  electricity: 'Electricity',
  temperature: 'Temperature',
  pressure: 'Pressure',
  frequency: 'Frequency',
  power: 'Power',
  runTime: 'Running Time'
}

const renzhen = {
  title: 'List of maintenance vouchers',
  fbillNo: 'Invoice number',
  fDate: 'Document time',
  availableQty: 'Available Quantity',
  frealQty: 'Actual shipment quantity',
  rkQty: 'Quantity Returned',
  rkState: 'Return Status',
  usedQty: 'Quantity Used',
  editTitle: 'Modify Coupon'
}

const warning = {
  title: 'Warning Types',
  add: 'Add warning type',
  recovery: 'Recovery type list',
  hide: 'Batch hiding',
  defaultTitle: 'Default Title',
  hiddenTypes: 'Hiddent Types',
  show: 'show',
  warningTypes: 'Warning Types',
  noHiddenWarningType: 'No hidden Types',
  confirmHide: 'Confirm to hide?',
  confirmHideContent: 'Click to confirm the hidden alert type',
  countTitle: 'Current type has',
  hide_o: 'hide',
  check: 'check',
  ignoreInfo: 'warn after',
  ignoreForever: 'Never remind',
  index: 'index',
  content: 'content',
  value: 'value',
  offlineDays: 'Offline Days',
  saleOrg: 'Marketing Organization',
  avgPressure: 'Average Pressure(MPa)',
  ratedPressure: 'Rated Pressure(MPa)',
  avgFrequency: 'Average Frequency(Hz)',
  ratedFrequency: 'Rated Frequency(Hz)',
  lowerLimitFrequency: 'Lower Limit Frequency(Hz)',
  avgTemperature: 'Average Temperature(℃)',
  percentage_air: 'Percentage',
  createdAt: 'Warning Time',
  salesRole: 'Marketing Role',
  serviceOrg: 'Service Organization',
  serviceName: 'Service Man',
  serviceRole: 'Service Role',
  avgCurrent: 'Average Current(A)',
  ratedCurrent: 'Rated Current(A)',
  fanTemperature: 'Fan Temperature(℃)',
  ratedTemperature: 'Rated Temperature(℃)',
  percentage_heat: 'Percentage',
  percentage_overflowing: 'Percentage',
  percentage_low: 'Percentage',
  outputFrequency: 'Output Frequency(Hz)',
  outputPower: 'Output Power(kw)',
  inverterTemperature: 'Inverter Temperature(℃)',
  conversionRatedPower: 'Conversion Rated Power(kw)',
  ratedPower: 'RatedPower(kw)',
  percentage_block: 'Percentage',
  percentage_overload: 'Percentage',
  leaveDays: 'Leave Days',
  leaveHours: 'Leave Hours',
  runTime: 'Running Time(h)',
  maintainTime: 'Maintain Time(h)',
  registerTime: 'Register Time',
  maintainTimeSetting: 'Maintain Time Setting(h)',
  exhaustPressure: 'Exhaust Pressure(MPa)',
  exhaustTemperature: 'Exhaust Temperature(℃)',
  mainSpeed: 'Main Speed(%)',
  airFilterElementValue: 'Air Filter Element Value',
  airFilterElementRunTime: 'Air Filter Element Running Time(h)',
  airFilterElementMaintainTime: 'Air Filter Element Maintain Time(h)',
  inletVacuum: 'InletVacuum(MPa)',
  duration: 'Duration(h)',
  oilDrumPressure: 'Oil Drum Pressure(MPa)',
  outputCurrent: 'Output Current(A)',
  oilSeparatorValue: 'Oil Separator Value',
  oilSeparatorRunTime: 'Oil Separator Running Time(h)',
  oilSeparatorMaintainTime: 'Oil Separator Maintain Time(h)',
  inletTemperature: 'Inlet Temperature(℃)',
  oilInletPressure: 'Oil Inlet Pressure(MPa)',
  oilInletTemperature: 'Oil Inlet Temperature(℃)',
  temperatureValue: 'Temperature Warning Value',
  oilRunTime: 'Oil Running Time(h)',
  oilMaintainTime: 'Oil Maintain Time(h)',
  mainFanInverterTemperature: 'Main Fan Inverter Temperature(℃)',
  mainFanOutRate: 'Main Fan Out Rate(Hz)',
  inverterTemperatureValue: 'Inverter Temperature Value',
  motorBearingTemperature: 'Motor Bearing Temperature(℃)',
  motorWindingTemperature: 'Motor Winding Temperature(℃)',
  motorBearingTemperatureValue: 'Motor Bearing Temperature Value',
  greaseRunTime: 'Grease Running Time(h)',
  greaseMaintainTime: 'Grease Maintain Time(h)',
  motorBearingRunTime: 'Motor Bearing Running Time(h)',
  motorWindingTemperatureValue: 'Motor Winding Temperature Value',
  lowOilInletPressureValue: 'Low Oil Inlet Pressure Value',
  oilFilterRunTime: 'Oil Filter Running Time(h)',
  oilFilterMaintainTime: 'Oil Filter Maintain Time(h)',
  note: 'Warning record',
  record: 'information',
  errorNo: 'Error Code',
  eelectric: 'Error Current',
  etime: 'Error Time',
  etemperature: 'Error Temperature',
  ebus: 'Error Bus',
  efrequency: 'Error Frequency',
  epressure: 'Error Pressure',
  eoutputVoltage: 'Error Outout Voltage',
  eio: 'Error IO',
  device: 'Device Warning',
  station: 'Station Warning',
  deleted: 'Is Deleted',
  swt: 'Please select a warning type',
  lastYearMaintainTime: 'Last Year Maintain Time',
  lastYearRunTime: 'Last Year Run Time',
  deletedWarning: 'Deleted Warnings',
  recovery: 'Recovery',
  confirmRecovery: 'Are you sure to restore?',
  confirmText: 'Click confirm to restore',
  multiple: "Multi-device Warning",
  avgMotorWindingTemp: "Average Motor Winding Temperature(℃)",
  maxMotorWindingTemp: "Maximum Motor Winding Temperature(℃)",
  avgEnvTemp: "Average Environment Temperature(℃)",
  maxEnvTemp: "Maximum Environment Temperature(℃)",
  lastMaintainTime: "Last Maintain Time",
  warningStatus: "Warning Status",
  addOrder: "Add order",
  warningOrder: "Warning Order",
  deviceCode: "Device Code",
  orderLevel: "Severity",
  orderDescription: "Description",
  handler: "Handler",
  reason: "Posible reason",
  emptyLevel: "Please select a severity",
  emptyDescription: "Please enter description",
  emptyHandler: "Please select a handler",
  emptyReason: "Please select a posible reason",
  editOrder: "Update order",
  history: "History",
  operator: "Operator",
  otherWarnings: "Other warnings",
  vibration: "Machine Vibration",
  runTime: "Run time(h)",
  maintainTime: "Maintain Time(h)",
  frequency: "Frequency(Hz)",
  vibration: "Vibration",
  setFields: "Set Fields",
  noDevice: "No device",
  avgOilDrumPressure: " Oil Drum Pressure(MPa)"
}

const warningForm = {
  sct: 'Please select a constrained type',
  and: 'And',
  or: 'Or',
  judgeCondition: 'Judgement Condition',
  add: 'Add warning',
  delete: 'Delete template',
  judge: 'Judge',
  value: 'Value',
  content: 'Content',
  mobile: 'Notification Phone Number',
  duration: 'Duration',
  notifyInterval: 'Notification Interval',
  empty: 'No warning',
  fail: 'Submission failed, please try again later',
  none: '-- None --',
  template: 'Template',
  st: 'Please select a template',
  swmn: 'Please enter the warning name (no more than 20 words)',
  swm: 'Please enter the warning name',
  DEVICE_STATUS: 'Off-line Warning',
  DEVICE_PARAMETER: 'Parameter Warning',
  strategyConstraint: 'Constrained Type',
  encn: 'Please enter the notification content (no more than 120 words)',
  enc: 'Please enter the notification content',
  noticeFrequency: 'Notification frequency (hours)',
  snf: 'Please select notification frequency',
  warningLevel: 'Warning Level',
  swl: 'Please select a warning level',
  URGENT: 'Urgent',
  IMPORTANT: 'Important',
  MINOR: 'Ninor',
  PROMPT: 'Prompt',
  effectiveTime: 'Effective Time',
  noticeCnt: 'Notification Count',
  recoveryNotice: 'Notice when recovery',
  warningRepeat: 'Effective period',
  swr: 'Please enter effective period',
  Sunday: 'Sunday',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  description: 'Description',
  ed: 'Please enter warning description',
  addCondition: 'Add confition',
  undo: 'Revocation',
  valueType: 'Value Type',
  monitorTime: 'Monitoring Duration',
  addMobile: 'Add mobile',
  phoneNumber: 'Phone Number',
  userRole: 'User Role',
  SMSEnable: 'SMS Enable',
  warningRecord: 'Warning Record',
  submitTemplate: 'Save sas template',
  deviceStatus: 'Device Status',
  deviceParamter: 'Device Parameter',
  n: 'The number of words cannot exceed ',
  ORIGIN: 'Origin',
  AVERAGE: 'Average ',
  MAX: 'Maximum',
  MIN: 'minimum',
  SUM: 'Summation',
  minutes: 'minutes',
  ealopn: 'Please enter at least one notification phone number',
  offline: 'Off-line Indicator',
  exitedTemplate: 'The warning template with the same name exists',
  ratioWarning: 'Gas-electricity ratio warning',
  noDevice: 'No Device',
  templateId: 'Template ID',
  schedule: "Schedule",
  scheduleDescription: "Description",
  cron: "Cron",
  cte: "Are you sure you want to enable it?",
  ctd: "Are you sure you want to disable it?",
  ce: "Click confirm button to enable",
  cd: "Click confirm button to disable",
  operator: "Operator",
  setExpression: "Generate expression",
  expression: "Expression",
  so: "Please select a operator",
  sm: "Please select a monitor time",
  ee: "Expression error",
  gap: "Gap",
  int: "Please enter a integer"
}

const dataReport = {
  addTemplate: 'add template',
  priority: 'priority',
  templateName: 'name',
  editTemplate: 'edit template',
  deleteTemplate: 'delete template',
  day: 'day',
  week: "week",
  month: 'month',
  year: 'year',
  calculation: 'statement of calculation',
  exportColumns: 'Columns to export',
  datetime: 'Time',
  timeRange: "Time Range",
  avgGasConsumption: 'Average Gas Consumption',
  flowMeterAccumulation: 'Flow Meter Accumulation',
  avgPower: 'Power Per Hour',
  electricityMeterAccumulation: 'lectricity Meter Accumulation',
  avgPressure: 'Average Pressure',
  avgConsumption: 'Average Consumption',
  specificPower: 'Specific Power',
  gasElectricRatio: 'Old Gas Electric Ratio',
  unitConsumption: "Unit Consumption",
  rfs: "Flow start count",
  rfe: "Flow end count",
  res: "Electricity start count",
  ree: "Electricity end count",
  comparison: "Data Comparison",
  compare: "Compare",
  increase: "Increase Rate",
  weekFormatter: "Week WW of yyyy",
  confirmToDeleteModel: "Confirm to delete the template ?",
  clickToConfirmDelete: "Click the confirm button to delete",
  checkeExtremeValue: "Check the extreme value",
  noDevice: "No flow meter and electricity meter in this station",
  selectTimeRange: "Please select a time range",
  LLJ: "Flow meter data",
  DB: "Electricity meter data",
  points: "Points",
  LLJDB: "Flow meter + Electricity meter",
  gasElectricRatio: "Gas ElectricRatio",
  result: "Result",
  origin: "Origin Data"
}

const role = {
  title: 'Roles List',
  columns: {
    name: 'Name',
    privilegeLevel: 'Privilege Level',
    enabled: 'Enabled'
  },
  copy: 'Copy',
  clipboard: 'Clipboard',
  importAuth: 'Import menus and permissions'
}

const permission = {
  title: 'Role and Permission',
  pRole: 'Parent role',
  name: 'Role name',
  dataScope: 'Data scope',
  to: 'the organization',
  tois: 'the organization and its subordinates',
  s: 'self',
  dt: 'Device type',
  e: 'Enquiry in person',
  userDataScope: 'User Data Scope'
}

const menu = {
  title: 'Menu List',
  name: 'Name',
  isMobile: 'Platform',
  icon: 'Icon',
  pMenu: 'Parent Menu',
  enabled: 'Enabled',
  type: 'Type',
  catalogue: 'catalogue',
  menu: 'menu',
  route: 'Route',
  alias: 'Route Alias',
  authorities: 'Authorities',
  englishName: 'English Name',
  priority: 'Priority'
}

const organization = {
  title: 'Organizations List',
  enabled: 'Enabled',
  name: 'Name',
  p: 'Parent Organization',
  code: 'Code'
}

const dict = {
  title: 'Dict List',
  name: 'Dict Type Name',
  typeCode: 'Dict Type code',
  'zh-CN': 'Dict Type Name(Chinese)',
  'en-US': 'Dict Type Name(English)',
  code: 'Code',
  addTitle: 'Add Dict',
  editTitle: 'Edit Dict',
  text: 'zh-CN',
  en: 'en-US',
  value: 'Value',
  insert: 'Insert Dict'
}

const client = {
  title: 'Client List',
  code: 'Client Code',
  name: 'Client Name',
  stationScope: 'Station Scope',
  authorities: 'Authorities',
  stations: 'Stations',
  authorityList: 'Auhtorities List',
  stationCode: 'Station Code',
  stationName: 'Station Name',
  'zh-CN': 'Authority Name',
  authCode: 'Authority Code',
  addTitle: 'Add Client',
  editTitle: 'Edit Client'
}

const linkage = {
  title: 'Linkage Devcie Group',
  groupCode: 'Linkage Code',
  groupName: 'Linkage Name',
  enabled: 'Enabled',
  createdAt: 'Creation Time',
  updatedAt: 'Update Time',
  basicInfo: 'Basic Information',
  masterDevice: 'Master Device',
  operationCode: 'Operation Code',
  statusCondition: 'Status Condition',
  slaveDevice: 'Slave Devices',
  soc: 'Please select a operation code',
  ssc: 'Please select a status codition',
  ssct: 'Status Condition Selecting',
  command: 'Command',
  sc: 'Please select a command',
  searchPoints: 'Search points',
  cs: 'Command Selecting',
  empty: 'No writable points',
  create: 'create',
  extra: '#point code=value;',
  egn: 'Please enter group name',
  code: 'Code',
  name: 'Name',
  unit: 'Unit',
  coefficient: 'Coefficient',
  sm: 'Please set a mater device',
  masterCondition: 'Master Device Condition',
  or: 'or',
  and: 'and',
  mt: 'Template of Master Devices',
  st: 'Template of Slave Devices'
}

const YSB = {
  title: 'YSB Staff List',
  name: 'Name',
  mobile: 'Mobile',
  addTitle: 'Add staff',
  editTitle: 'Edit staff',
  JDOrganization: 'JDY Organization',
  JDDepartment: 'JDY Department'
}

const param = {
  title: 'Parameters Setting',
  searchDevice: 'Device',
  deviceCode: 'Search Device Code',
  writeOrRead: 'Aspect',
  write: 'Write',
  read: 'Read',
  number: 'Please enter a number less than 65535',
  selectParam: 'Param',
  searchParam: 'Search Params',
  address: 'Address',
  createText: 'Create text',
  command: 'AT',
  createContent: 'Content',
  send: 'Send',
  returnedContent: 'Received'
}

const modification = {
  title: 'Device Modification Count',
  count: 'Count',
  details: 'Show details',
  user: 'User',
  points: 'Points'
}

const module = {
  title: 'Undismantled Module',
  powerOnTime: 'Power On Time'
}

const devicePosition = {
  title: 'Device location history',
  positionUpdatedAt: 'Position Update Time',
  longitude: 'Longitude',
  latitude: 'Longitude',
  showMap: 'Show Map',
  noHistory: 'The device has no location change record',
  arriveTime: 'Arrival Time'
}

const protocol = {
  title: 'Protocol',
  searchCodeOrName: 'Search code or name',
  importP: 'Import protocol',
  public: 'Public',
  private: 'private',
  copy: 'Copy protocol',
  name: 'Name',
  type: 'Type',
  retryCnt: 'Retry Count',
  timeout: 'Timeout',
  intervalTime: 'Interval',
  atLeastOnePro: 'Please select at least one protocol',
  new: 'Please enter a new protocol number',
  sync: 'Sync',
  ignoreCode: 'Igonore Code',
  ignoreInfo: '*This parameter is none Ignore a single record',
  warningTemplate: 'Warning Template',
  addPoint: 'Add point',
  sum: 'Cumulant',
  fluctuation: 'Fluctuation',
  sst: 'Please select a statistic type',
  sct: 'Please select a code devimal',
  svt: 'Please select a data type',
  spt: 'Please select a read-write mode',
  sbo: 'Please select a byte corder',
  readonly: 'Read Only',
  wirte: 'Write',
  switch: 'Switch',
  saw: 'Please select a data write',
  sdl: 'Please select a data level',
  open: 'open',
  close: 'close',
  convertRules: 'ConvertRules',
  virtualPointSetting: 'Virtual Point Setting',
  addTemplate: 'Add template',
  ec: 'Please enter a code',
  dcs: 'Do not enter special characters',
  cr: 'Data point encoding duplicates',
  pce: 'The protocol code already exists',
  syncFail: 'Synchronization failed. Please try again later',
  virtualPoint: 'Only virtual data points are supported',
  wirteOnly: 'Write only',
  war: 'Read-write',
  e: 'Please enter ',
  cpi: 'Please complete the point information',
  sm: 'Please select a match',
  etv: 'Please enter the target value',
  esv: 'Please enter a display value',
  et: 'Please enter a status marker',
  ep: 'Please enter the bit number',
  en: 'Please enter name',
  virtualPointTitle: 'Virtual Point',
  epn: 'Please enter protocol name',
  selectProtocolType: 'Please select protocol type',
  ei: 'Please enter interval time',
  eto: 'Please enter timeout',
  erc: 'Please enter retrying count',
  nlt20: "20Please don't enter more than 20 words",
  nlt120: "Please don't enter more than 20 words",
  epl: 'Please enter this points number limit per request',
  name_zh: "Name in chinese",
  name_en: "Name in English",
  zero_zh: "Chinese for 0",
  zero_en: "English for 0",
  one_zh: "Chinese for 1",
  one_en: "English for 1",
  value_zh: "Value in chinese",
  value_en: "Value in english",
  match: "Convert Value"
}

const resources = {
  title: 'Source Mangement',
  upload: 'Upload',
  code: 'Code',
  category: 'Category',
  url: 'Source',
  uploadTime: 'Upload Time',
  deleteFile: 'Delete file',
  resourceCategary: 'Resource Category'
}

const binding = {
  KYJ: 'Air Compressor',
  LGJ: 'Refrigeration Dryer',
  ordersQuery: 'Invoice number',
  dateOut: 'Outbound Date',
  searchConditions: 'Search Conditions',
  provideModel: 'Supplier Model',
  customerInfo: 'Customer Information',
  customerName: 'Customer Name',
  acceptAddress: 'Customer Address',
  contractManager: 'Customer Contact',
  contractPhone: 'Contact Way',
  province: 'Province',
  city: 'City',
  provincial: 'Area',
  serviceInfo: 'After-sales Information',
  salesMen: 'Salesman',
  ssm: 'Please select a salesman',
  salesPhone: 'Sales Phone Number',
  serviceMan: 'Service Personnel',
  ssem: 'Please select a service personnel',
  servicePhone: 'Service Phone Number',
  regist: 'Regist',
  current: 'Current ',
  dontExit: 'does not exist, whether to add',
  continue: 'Do you want to continue to register? Click OK to continue registration and click Cancel to return to editing',
  orderCode: 'Order code',
  secondSale: 'Is Second Sale',
  terminalCustomer: 'Terminal Customer Name',
  saleDepartment: 'Sale Department',
  epr: 'Please enter area',
  ec: 'Please enter city',
  ep: 'Please enter province',
  eqdc: 'Please enter the machine number you want to query',
  confirmProtocolCode: 'Confirm protocol code',
  diffProtocolCode: 'The protocol number is different from the setting, which is: ',
  noDeviceInfo: 'No device information is available',
  exitDevice: 'Devices with duplicate numbers exist. Procedure',
  diffModel: 'Specifications and models are not equal to supplier models',
  dtuCodeLength: "The module number contains less than 6 characters. Please check whether the module number is correct",
  exitDtuCode: 'Please check whether the module number is the same',
  addUserScuccess: 'Adding a user succeeded',
  updateCustomerSuccess: 'Update customer success',
  addCustomerSuccess: 'New customer success',
  updateDevice: 'Device update succeeded',
  addDevice: 'Succeeded in adding a device',
  hostCode: 'Host Code',
  ygkCustomer: 'YGK Customer',
  edc: 'Please enter the machine code',
  asa: 'Please confirm if you want to add a new sales man: ',
  ase: 'Please confirm if you want to add a new service man: ',
  osa: ', existing sales men: ',
  ose: ', existing service men: ',
  resend: 'Resend',
  unRegCustomer: 'Unregistered Customers',
  customerShortName: 'Customer Short Name',
  areaManager: 'Regional Manager',
  shrAddress: 'Contact Address',
  differentDtuCode: "Different dtucode"
}

const visitRecords = {
  importSuccessfully: 'Import successfully',
  title: 'Revisit Records',
  import: 'Import',
  department: 'Department',
  machineName: 'Machine Name',
  serviceItem: 'Service Content',
  phone: 'Contact Phone Number',
  q1: 'Question 1: Service attitude',
  q2: 'Question 2: 5s satisfaction',
  q3: 'Question 3: How does the machine work after maintenance',
  q4: 'Question 4: Recommendation level',
  totalScore: 'Aggregate Score',
  activityName: 'Year',
  sy: 'Please select year',
  area: 'Month',
  sm: 'Please select month',
  minusScoreReason: 'Non-perfect reason',
  minusScoreReasonIF: 'Reasons for non-full marks (including unsuccessful return visit)',
  statisticsMonth: ' monthly return visit statistics',
  team: 'Team',
  totalVisits: 'Total return visits',
  satisfactionNum: 'Satisfied customers',
  satisfactionRate: 'Satisfaction rate',
  year: '.',
  month: ' ',
  analyse: 'After-sales return visit analysis',
  success: 'Successful return visit',
  ratio: 'Proportion',
  fullScore: 'Full mark',
  minusScore: 'Imperfect mark',
  fail: 'The return visit was unsuccessful',
  failReason: 'Reasons for failure',
  num: 'Quantity'
}

const report46 = {
  unaudited: 'Unaudited',
  audited: 'Audited',
  title: 'List of 46 comprehensive maintenance reports',
  auditState: 'Audit Status',
  progress: 'Progress of review',
  completeState: 'Current filling status',
  audit: 'Audited',
  exportTitle: '46 comprehensive maintenance reports',
  file: '-file',
  checkItem: 'Check and Maintain Items',
  range: 'Reference Range',
  before: 'Pre-maintenance',
  after: 'After-maintenance',
  starRating: 'Star rating: ',
  remark: 'Remark: ',
  customerSignature: 'Customer Signature: ',
  reportCode: 'Report Code: ',
  maintenanceDate: 'Maintain Date',
  export: 'Export '
}

const funnel = {
  industryClassification: 'Industry Classification',
  businessType: 'Business Type',
  projectName: 'Project Name',
  startTime: 'Project Follow-up Start Time',
  budgetedAmount: 'Budgeted Amount',
  currentStage: 'Current Stage',
  winPercent: 'Winning percentage',
  expectedOutput: 'Expected Output',
  contractAmount: 'Contract Amount',
  customerLeadDepartment: 'Customer Lead Department',
  relevantContact: 'Relevant Contact',
  customerStakeholders: 'Customer Stakeholders',
  keyman: 'Key Decision Maker',
  demandContent: 'Demand Content',
  currentProgress: 'Current Progress',
  nextVisitTime: 'Next Visit Time',
  competitor: 'Competitor',
  visitContent: 'Visit Content',
  cooperativePartner: 'Cooperative Partner',
  determine: 'Determine',
  failureReason: 'Failure Reason',
  details: 'Details',
  ss: 'Select the project follow-up start time'
}

const recordDetail = {
  funnel: 'Sales Funnel',
  followRecord: 'Follow Record',
  ordered: 'Formed',
  nOrdered: 'Unformed',
  reportValid: 'Report valid',
  reportInvalid: 'Report invalid',
  er: 'Please enter the applicant',
  es: 'Please enter salesman',
  sa: 'Please select a company address',
  el: 'Please enter contact person',
  eln: 'The contact number cannot be empty',
  ek: 'Please enter a decision maker',
  ekn: "The decision maker's phone number cannot be empty",
  ecd: 'Please enter customer requirements',
  eom: 'Please enter the original model',
  eept: 'Please enter the estimated purchase time',
  sis: 'Please select the source of information',
  ecb: 'Please enter the customer affiliation',
  recommit: 'This order has been reported as invalid and cannot be resubmitted',
  oldCustomerInfo: 'Old customer information',
  reportedInfo: 'Reported information',
  completeForm: 'Please fill in the company name, contact phone, and decision maker’s phone before checking for duplicates',
  delayReason: 'Please enter the reason for the extension',
  title: 'Report record details',
  reportTime: 'Report time',
  reporter: 'Reporter',
  reporterOrganization: 'Reporter organization',
  duplicate: 'Check for duplicates',
  policymaker: 'Decision maker',
  policymakerNum: 'Decision maker phone number',
  customerDemand: 'Customer requirements',
  originalModel: 'Original model',
  customerBelong: 'Customer affiliation',
  informationSources: 'Information source',
  estimatedPurchaseTime: 'Estimated purchase time',
  isorder: 'Order formed',
  state: 'Record Status',
  failReason: 'Invalid reason',
  cdjx: 'Ordered model',
  ycyy: 'Extension reason',
  delete: 'Press delete key to delete',
  area: 'Province, city, district',
  province: 'Please select province',
  city: 'Please select city',
  region: 'Please select county or district',
  town: 'Please select town or street',
  submit: 'Submit',
  reportRecord: 'Report record',
  addFollowRecord: 'Add follow-up record',
  nextVisitTime: 'Next follow-up time',
  nextVisitGoal: 'Next follow-up goal',
  writeTime: 'Fill in time',
  trackSituation: 'Follow-up situation'
}

const calcCDL = {
  salemanName: 'Information Manager',
  netRate: 'Conversion Rate',
  netCD: 'Completed Orders',
  netInfoRate: 'Network Information Proportion%',
  netBD: 'Report Quantity',
  faRate: 'Conversion Rate%',
  faCD: 'Completed Orders',
  faBD: 'Report Quantity',
  factoryInfoRate: 'Factory Information Proportion% (After-Sales Installation)',
  selfInfoRate: 'Self Information Proportion%',
  infoSourceRate: 'Order Information Report Source Classification and Proportion%',
  newRate: 'New Customer Conversion Proportion%',
  newCD: 'New Customer Completed Orders',
  newNum: 'New Customers',
  oldRate: 'Old Customer Conversion Proportion%',
  oldCD: 'Old Customer Completed Orders',
  oldNum: 'Old Customers',
  oldNewRate: 'Proportion of New and Old Customers in Completed Orders',
  totalCD: 'Total Completed Orders',
  totalJD: 'Total Orders Received'
}

const recordsList = {
  char6: 'Please enter at least 6 characters',
  address: 'Please enter a detailed address',
  overdue: 'Expired',
  recordTime: 'Sort by report time',
  expirationTime: 'Sort by report expiration time',
  myReport: 'My Report',
  elseReport: 'Others\' Report',
  empty: 'No records selected',
  keyword: 'Keyword',
  order: 'Sort',
  type: 'Record Type',
  add: 'Add Report',
  info: 'Follow-up Information',
  state: 'Status',
  customerDemand: 'Report Expiration Time',
  wasDue: 'Expired',
  addInfo: 'Add Report Information',
  eun: 'Please enter username'
}

const SIM = {
  title: "SIM Management",
  giccid: "GICC ID",
  status: "SIM Status",
  currentBasicServicePackageName: "Current Basic Service Package Name",
  currentCycleDataUsage: "Current Cycle DataUsage (KB)",
  activatedTime: "Activated Time",
  sellTime: "Sell Time",
  deviceCode: "Device Code",
  deviceName: "Device Name",
  model: "Model",
  deviceType: "Device Type",
  deviceStatus: "Device Status",
  company: "Company",
  organization: "Organization",
  activate: "Activate",
  deactivate: "Deactivate",
  retire: "Retire",
  cta: "Confirm to activate",
  ctd: "Confirm to deactivate",
  ctr: "Confirm to retire",
  createdAt: "Device Creation Time",
  multiple: "This module is bound to multiple SIM cards.",
  empty: "This module is not bound to a SIM card.",
  powerOnTime: "Power on time",
  sync_dtu: "Sync",
  cts: "Confirm to sync"
}

const time = {
  week: "After a week",
  halfMonth: "After half a month",
  month: "After a month",
  threeMonths: "After three months",
  halfYear: "After six months",
  year: "After a year"
}

const warningOrder = {
  code: "Order Code",
  status: "Order Status",
  handlerPhoneNumber: "Phone number of handler",
  handleMethod: "Handle Method",
  followerPhoneNumber: "Phone number of follower",
  solution: "Solution",
  estimatedTime: "Estimated Time",
  processedTime: "Processed Time",
  handledTime: "System handled time",
  handle: "Handle",
  finish: "Finish",
  comment: "Comment",
  enterEstimatedTime: "Please select a estimated time",
  resolvable: "Unresolvable",
  live: "Field Situation",
  handledDetails: "Handle Details",
  noComments: "No Comments",
  enterComment: "Please enter comment content",
  reply: "Reply",
  confirmToDelete: "Are you sure to delete this comment?",
  confirm: "Click the confirm button to delete",
  ctdo: "Confirm to delete the order ?",
  selectHandleMethod: "Please select a handle method",
  orderDetail: "Order Detail",
  orderInfo: "Order Info",
  noReasons: "No Reasons",
  saveFirst: "There are unsaved changes. Please save first.",
  noHandleMethods: "No handle methods",
  confirmToDeleteReason: "Are you sure to delete this reason?",
  confirmToDeleteHandleMethod: "Are you sure to delete this handle method?",
  confirmReason: "Click the confirm button to delete",
  confirmHandleMethod: "Click the confirm button to delete",
  reasonSetting: "Reason Setting",
  methodSetting: "Handle Method Setting"
}

const deviceWarningsCount = {
  title: "Device Warnings"
}

const warningHistory = {
  title: "Warning History"
}

export default {
  documentTitle: 'Deman energy-saving air compressor data platform',
  tagsClose: 'Close the following tabs',
  common,
  messages,
  buttons,
  login,
  overview,
  user,
  customer,
  placeholder,
  device,
  orders,
  saleDocument,
  station,
  configuration,
  history,
  maintain,
  runningData,
  renzhen,
  warning,
  dataReport,
  statistics: 'Statistics',
  warn: 'Warn',
  tableS: 'Table Setting',
  confirm: 'confirm to delete',
  line: 'Line',
  bar: 'Bar',
  min: 'minimum: ',
  max: 'maximum: ',
  sa: 'Select all',
  role,
  permission,
  menu,
  organization,
  linkage,
  dict,
  client,
  YSB,
  param,
  modification,
  module,
  devicePosition,
  warningForm,
  protocol,
  resources,
  binding,
  order_operators,
  visitRecords,
  report46,
  funnel,
  recordDetail,
  calcCDL,
  recordsList,
  region,
  SIM,
  time,
  warningOrder,
  deviceWarningsCount,
  warningHistory
}
